import { useChangePasswordForm } from "@/hooks/useChangePasswordForm";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound, Loader2 } from "lucide-react";

const FIELDS = [
  { id: "cur-pw", label: "Current password", key: "cur", setKey: "setCur", testid: "current-password-input" },
  { id: "new-pw", label: "New password", key: "next", setKey: "setNext", testid: "new-password-input", placeholder: "At least 8 characters" },
  { id: "confirm-pw", label: "Confirm new password", key: "confirm", setKey: "setConfirm", testid: "confirm-password-input" },
];

export default function ChangePasswordDialog() {
  const f = useChangePasswordForm();

  return (
    <Dialog open={f.open} onOpenChange={f.onOpenChange}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="border-zinc-300" data-testid="change-password-btn" title="Change password">
          <KeyRound className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif">Change password</DialogTitle>
          <DialogDescription>Update the password for your account.</DialogDescription>
        </DialogHeader>
        <form onSubmit={f.submit} className="space-y-4">
          {FIELDS.map((fl) => (
            <div key={fl.id} className="space-y-1.5">
              <Label htmlFor={fl.id}>{fl.label}</Label>
              <Input
                id={fl.id} type="password" required value={f[fl.key]}
                onChange={(e) => f[fl.setKey](e.target.value)}
                placeholder={fl.placeholder} data-testid={fl.testid}
              />
            </div>
          ))}
          <DialogFooter>
            <Button type="submit" disabled={f.loading} className="bg-[#002FA7] hover:bg-[#002687] text-white h-10" data-testid="change-password-submit">
              {f.loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Update password
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
